// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97a60491","453":"256a5495","467":"2d612117","667":"f123da54","707":"3fe6e0dc","768":"8cd683c1","897":"cffb45f2"}[chunkId] + ".chunk.js";
};